<template>
  <v-dialog
    id="user-update-password-modal-form"
    ref="userUpdatePasswordModalForm"
    v-model="$store.state.userUpdatePasswordModalFormOpen"
    width="400"
    :disabled="!isPermittedAll(['PasswordUpdate'])"
    persistent
    no-click-animation>
    <form
      @submit.prevent="savePassword">
      <v-container
        class="px-5 pb-2 pt-0">
        <!-- Title -->
        <v-row>
          <v-col
            class="d-flex pr-0">
            <h2>
              <span
                v-if="$store.getters.isUserUpdatePasswordFormDirty">
                *
              </span>
              Update Password
            </h2>
            <v-btn
              class="square ml-auto"
              type="button"
              text
              @click="closeUserUpdatePasswordModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Title -->

        <!-- Current Password -->
        <v-row>
          <v-col>
            <v-text-field
              id="current-password"
              name="currentPassword"
              ref="currentPassword"
              type="password"
              v-model="activeUserUpdatePassword.CurrentPassword"
              label="Current Password:"
              :readonly="$store.getters.isLoadingActive"
              hide-details>
            </v-text-field>
          </v-col>
        </v-row>
        <!-- / Current Password -->

        <!-- New Password -->
        <v-row>
          <v-col>
            <v-text-field
              id="new-password"
              name="newPassword"
              ref="newPassword"
              type="password"
              v-model="activeUserUpdatePassword.NewPassword"
              label="New Password:"
              :readonly="$store.getters.isLoadingActive"
              hide-details>
            </v-text-field>
          </v-col>
        </v-row>
        <!-- / New Password -->

        <!-- New Password Confirm -->
        <v-row>
          <v-col>
            <v-text-field
              id="new-password-confirm"
              name="newPasswordConfirm"
              ref="newPasswordConfirm"
              type="password"
              v-model="activeUserUpdatePassword.NewPasswordConfirm"
              label="Confirm New Password:"
              :readonly="$store.getters.isLoadingActive"
              hide-details>
            </v-text-field>
          </v-col>
        </v-row>
        <!-- / New Password Confirm -->

        <!-- Buttons -->
        <v-row>
          <v-col
            class="d-flex align-end">
            <v-btn
              class="ml-auto"
              type="submit"
              color="primary"
              :disabled="$store.getters.isLoadingActive
                || !$store.getters.isUserUpdatePasswordFormDirty">
              Save
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Buttons -->
      </v-container>
    </form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'UserUpdatePasswordModalForm',
  computed: {
    activeUserUpdatePassword() {
      return this.$store.state.activeUserUpdatePassword;
    },
  },
  methods: {
    closeUserUpdatePasswordModal(skipDirtyCheck) {
      const confirm = () => {
        this.$store.commit('setUserUpdatePasswordModalFormOpen', false);
        setTimeout(() => {
          this.$store.commit('setActiveUserUpdatePassword');
        }, 200);
      };

      if (this.$store.getters.isUserUpdatePasswordFormDirty && !skipDirtyCheck) {
        this.showConfirm(
          'Are you sure you want to leave without saving?',
          'You have unsaved changes',
        ).then(confirm, _.noop);
      } else {
        confirm();
      }
    },
    savePassword() {
      this.$store.dispatch('updatePassword')
        .then(() => this.closeUserUpdatePasswordModal(true));
    },
  },
};
</script>

<style lang="scss"></style>
